import { render, staticRenderFns } from "./home.vue?vue&type=template&id=2c36862c&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "../../assets/commoon/css/common.css?vue&type=style&index=0&id=2c36862c&prod&scoped=true&lang=css&external"
import style1 from "./home.vue?vue&type=style&index=1&id=2c36862c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c36862c",
  null
  
)

export default component.exports